

import { LogCategory, log } from '../api/logger';

var Page = require('./../constants/page');


export default (page, args) => {
        var http = "";

        switch ( page  ) {
            case Page.ActiveMaintenanceFull:    http = "/activeMaintenanceFullPage"; break;
            case Page.ActiveMaintenanceSmall:   http = "/activeMaintenanceSmallPage"; break;
            case Page.BillingAddress:           http = "/billingAddressPage"; break;
            case Page.CardInfo:                 http = "/cardInfoPage"; break;
            case Page.ExpiredContractFull:      http = "/expiredContractFullPage"; break;
            case Page.ExpiredContractSmall:     http = "/expiredContractSmallPage"; break;
            case Page.ExpiringContractFull:     http = "/expiringContractFullPage"; break;
            case Page.ExpiringContractSmall:    http = "/expiringContractSmallPage"; break;

            case Page.Freemium:                 http = "/freemiumPage"; break;
            case Page.FreemiumOverMaxVersion:   http = "/freemiumOverMaxVersionPage"; break;

            case Page.MaintenanceOptions:       http = "/maintenanceOptionsPage"; break;
            case Page.PaymentReview:            http = "/paymentReviewPage"; break;
            case Page.Paypal:                   http = "/paypalPage"; break;
            case Page.Netteller:                http = "/netellerPage"; break;
            case Page.PurchaseCompleteSuccess:  http = "/purchaseCompleteSuccessPage"; break;
            case Page.Purchase:                 http = "/purchasePage"; break;
            case Page.StartTrialOptions:        http = "/startTrialOptionsPage"; break;
            case Page.TrialLicense:             http = "/trialLicensePage"; break;
            case Page.TrialStarted:             http = "/trialStartedPage"; break;
            case Page.ViewMisseddUpdates:       http = "/viewMissedUpdatesPage"; break;

            case Page.SelectProducts:           http = "/selectProductsPage"; break;
            case Page.PreSelectProducts:           http = "/preSelectProductsPage"; break;
            case Page.ContinueTrial:            http = "/continueTrialPage"; break;

            case Page.UpgradeProduct:           http = "/upgradeProductsPage"; break;
            case Page.CouldNotLoadMla:          http = "/couldNotStartMlaPage"; break;

            case Page.GetHm3ForFree:            http= "/getHm3ForFreePage"; break;

            case Page.SelectHmAppsProducts:           http = "/selectHmAppsProductsPage"; break;
            case Page.SelectHmAppVariantProducts:           http = "/selectHmAppVariantProductsPage" + (args !== undefined ? "/" + args[0] : "/years"); break;

            default:
                log(LogCategory.info,'invalid page ' + JSON.stringify(page));
                http = "/error" ; break;
        }
        return http;
};




// WEBPACK FOOTER //
// ./src/dispatcher/pageUrl.js